const angular = require('angular')

import { STATE_CONFIG_PROVIDER, INestedState, StateConfigProvider } from 'core/navigation/state.provider';

export const STYLEGUIDE_STATES = 'spinnaker.core.styleguide.states';

angular.module(STYLEGUIDE_STATES, [STATE_CONFIG_PROVIDER])
  .config((stateConfigProvider: StateConfigProvider) => {

  const styleguideState: INestedState = {
    url: '/styleguide',
    name: 'styleguide',
    views: {
      'main@': {
        templateUrl: require('./public/styleguide.html')
      }
    },
    data: {
      pageTitleSection: {
        title: 'Styleguide'
      }
    }
  };
  stateConfigProvider.addToRootState(styleguideState);
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/styleguide/styleguide.states.ts